import { createContext } from 'react';
const defaultFeatureFlagContext = {
    flags: {},
    isLoading: false,
    isError: false,
    refetch: async () => { },
};
export const FeatureFlagContext = createContext(defaultFeatureFlagContext);
